import { useQuery } from "react-query";
import { remoteKeys } from "../apis";
import { getConnectionDefinition } from "../apis/integrations";
import { ConnectionDefinition } from "../../types/integrations";

export const useGetConnectionDefinition = ({
  definitionId,
  linkHeaders,
}: {
  definitionId: number;
  linkHeaders?: Record<string, unknown>;
}) => {
  const { data, isLoading } = useQuery<ConnectionDefinition>({
    queryKey: [remoteKeys.getConnectionDefinition, definitionId],
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24,
    retry: false,
    queryFn: () => getConnectionDefinition(definitionId, linkHeaders),
  });

  return { definition: data, isLoading };
};
